import React, { useState, useEffect } from 'react';
import { IoIosArrowBack, IoIosArrowForward, IoIosRadioButtonOff, IoIosRadioButtonOn } from 'react-icons/io';
import './style.css';
import FrameL from '../FrameL';

let interval;

const Carousel = ({ children, autoPlaySpeed, className }) => {
  const [index, setIndex] = useState(0);

  const handleForward = () => {
    setIndex(i => (i + 1) % children.length);
  }

  const handlePrevious = () => {
    setIndex(i => (i - 1 + children.length) % children.length);
  }

  useEffect(() => {
    if (autoPlaySpeed) {
      interval = setInterval(() => {
        handleForward();
      }, autoPlaySpeed);
    }

    return () => {
      clearInterval(interval);
    }
  }, []);

  return (
    <div className={`relative ${className}`}>
      {children.map((child, i) => {
        return <div key={i} className={`carousel-item ${index === i ? 'active' : ''}`}>
          {child}
        </div>
      })}

      <div className="absolute carousel__bottom text-white text-3xl flex flex-row justify-center">
        {children.map((_, i) => {
          if (index !== i) {
            return <IoIosRadioButtonOff key={i}></IoIosRadioButtonOff>
          }
          return <IoIosRadioButtonOn key={i}></IoIosRadioButtonOn>
        })}
      </div>
      <IoIosArrowBack
        className="absolute pointer-cursor carousel__prev text-white text-6xl"
        onClick={handlePrevious}></IoIosArrowBack>
      <IoIosArrowForward
        className="absolute pointer-cursor carousel__next text-white text-6xl"
        onClick={handleForward}></IoIosArrowForward>
    </div>
  );
};

Carousel.defaultProps = {
  autoPlaySpeed: 6000
};

export default Carousel;
